const isMetricList = (
  card: CanvasCard.Card,
): card is CanvasCard.MetricListCard => card.content.type === 'Metric List';

export default isMetricList;
